import { forwardRef } from "react";
import { StyledAlert } from "./Alert.style.js";
import { AlertProps, DefaultAlertProps } from "./Alert.types.js";

const defaultProps: DefaultAlertProps = {
    color: "primary",
    flat: false,
    textAlign: "center",
};

export const Alert = forwardRef<HTMLDivElement, AlertProps>((props, ref): JSX.Element => {
    const { children, ...attributes } = props;

    return (
        <StyledAlert {...defaultProps} {...attributes} ref={ref}>
            {children}
        </StyledAlert>
    );
});
